import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import type { Product } from '~/api/products/types';

import { AlertDialog, Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';
import { r, routes } from '~/providers/RouterProvider/router.routes';

import type { DialogHandles } from '../ProductsTable.hooks';

type Props = {
  dialogHandles: DialogHandles;
  product: Product;
};

export const ProductOptionsCell = ({ dialogHandles, product }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  return (
    <Menu.Root>
      <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

      <Menu.List>
        <Menu.Item icon="Edit" onClick={() => navigate(r(routes.editProduct, { productId: product.id }))}>
          {t('common:actions.edit')}
        </Menu.Item>

        <AlertDialog.Trigger
          handle={dialogHandles.deleteProductHandle}
          nativeButton={false}
          payload={product}
          render={<Menu.Item icon="Trash">{t('common:actions.delete')}</Menu.Item>}
        />
      </Menu.List>
    </Menu.Root>
  );
};
